import { cva } from 'class-variance-authority';

export const defaultFilterSelectTitleVariants = cva(
	'font-matter-sq text-lg font-normal leading-normal tracking-[-0.36px]',
	{
		variants: {
			variant: {
				primary: 'text-primary',
				dark: 'text-white'
			}
		},
		defaultVariants: {
			variant: 'primary'
		}
	}
);

export const defaultFilterSelectCommandVariants = cva(
	'absolute z-50 h-auto w-full',
	{
		variants: {
			variant: {
				primary: 'bg-white',
				dark: 'bg-primary-light-4'
			}
		},
		defaultVariants: {
			variant: 'primary'
		}
	}
);

export const defaultFilterSelectInputWrapperVariants = cva('border', {
	variants: {
		variant: {
			primary:
				'border-white-dark-4 hover:border-primary/40 hover:focus-within:border-primary focus-within:border-primary',
			dark: 'border-primary-light-3 hover:border-white-dark-4 focus-within:border-white-dark-4'
		}
	},
	defaultVariants: {
		variant: 'primary'
	}
});

export const defaultFilterSelectInputVariants = cva(
	'h-[50px] px-4 py-2 placeholder:text-sm',
	{
		variants: {
			variant: {
				primary: 'text-primary',
				dark: 'text-white placeholder:text-white-dark-4'
			}
		},
		defaultVariants: {
			variant: 'primary'
		}
	}
);

export const defaultFilterSelectIconVariants = cva('size-7', {
	variants: {
		variant: {
			primary: 'text-primary',
			dark: 'text-white'
		}
	},
	defaultVariants: {
		variant: 'primary'
	}
});

export const defaultFilterSelectCancelIconVariants = cva(
	'size-5 cursor-pointer',
	{
		variants: {
			variant: {
				primary: 'text-white-dark-3',
				dark: 'text-primary-light-1 hover:text-white'
			}
		},
		defaultVariants: {
			variant: 'primary'
		}
	}
);

export const defaultFilterSelectListVariants = cva('p-0', {
	variants: {
		variant: {
			primary: 'border-white-dark-4',
			dark: 'border-primary-light-3'
		}
	},
	defaultVariants: {
		variant: 'primary'
	}
});

export const defaultFilterSelectItemVariants = cva(
	'flex items-center justify-between px-4 py-3 text-base font-normal leading-normal',
	{
		variants: {
			variant: {
				primary: 'text-primary data-highlighted:bg-white-dark-2',
				dark: '!text-white data-highlighted:bg-primary-light-4'
			},
			isActive: {
				true: '',
				false: ''
			}
		},
		compoundVariants: [
			{
				variant: 'primary',
				isActive: true,
				class: 'bg-white-dark-2'
			},
			{
				variant: 'dark',
				isActive: true,
				class: 'bg-primary-light-4'
			}
		],
		defaultVariants: {
			variant: 'primary',
			isActive: false
		}
	}
);

export const defaultFilterSelectBadgeVariants = cva(
	'w-min cursor-pointer gap-2 whitespace-nowrap px-2 py-[5.5px] text-sm font-normal border-none h-8',
	{
		variants: {
			variant: {
				primary: '',
				dark: '!bg-white-dark-4 !text-primary'
			}
		},
		defaultVariants: {
			variant: 'primary'
		}
	}
);

export const defaultFilterSelectBadgeIconVariants = cva('size-5', {
	variants: {
		variant: {
			primary: '',
			dark: 'text-black'
		}
	},
	defaultVariants: {
		variant: 'primary'
	}
});

export const defaultFilterSelectHighlightTitleVariants = cva(
	'text-xs font-normal leading-normal',
	{
		variants: {
			variant: {
				primary: 'text-primary-light-1',
				dark: '!text-white-dark-4'
			}
		},
		defaultVariants: {
			variant: 'primary'
		}
	}
);

export const defaultFilterSelectHighlightBadgeVariants = cva(
	'w-min cursor-pointer gap-2 whitespace-nowrap px-2 py-[5.5px] text-sm font-normal border-none h-8',
	{
		variants: {
			variant: {
				primary: '',
				dark: '!bg-primary-light-4 !text-white'
			}
		},
		defaultVariants: {
			variant: 'primary'
		}
	}
);

export const defaultFilterSelectHighlightBadgeIconVariants = cva('size-5', {
	variants: {
		variant: {
			primary: 'text-primary',
			dark: 'text-white'
		}
	},
	defaultVariants: {
		variant: 'primary'
	}
});

export const defaultFilterSelectSkeletonPrimaryVariants = cva(
	'h-4 w-3/4 rounded',
	{
		variants: {
			variant: {
				primary: 'bg-white-dark-3',
				dark: 'bg-primary-light-3'
			}
		},
		defaultVariants: { variant: 'primary' }
	}
);

export const defaultFilterSelectSkeletonSecondaryVariants = cva(
	'h-3 w-1/2 rounded',
	{
		variants: {
			variant: {
				primary: 'bg-white-dark-4',
				dark: 'bg-primary-light-2'
			}
		},
		defaultVariants: { variant: 'primary' }
	}
);
